import type { Zone } from '@seek/audience-zones';
import type { Brand, Country, SiteName } from '@seek/melways-sites';
import { type PageAction, PageUpdateActionType } from './actionCreators';

export interface PageAnalytics {
  brand: Brand;
  country: Country;
  zone: Zone;
  site: SiteName;
}

export interface PageState {
  pageAnalytics: PageAnalytics;
}

const initialState: PageState = {
  pageAnalytics: {
    brand: 'seek' as Brand,
    country: 'au' as Country,
    zone: 'anz-1',
    site: 'candidate-seek-au',
  },
};

export default function reducer(
  state = initialState,
  { type, payload }: PageAction,
): PageState {
  switch (type) {
    case PageUpdateActionType.SET_BRAND_COUNTRY_ZONE: {
      return {
        ...state,
        pageAnalytics: {
          country: payload.country,
          brand: payload.brand,
          zone: payload.zone,
          site: payload.site,
        },
      };
    }

    default:
      return state;
  }
}
